// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(http://fonts.cdnfonts.com/css/vcr-osd-mono);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  display: grid;
  grid-template-columns: 2fr 3fr 2fr;
  font-size: 12px;
  padding: 10px 0;
  margin: 0 auto;
  grid-auto-rows: minmax(70px, auto);
}

.wrapper>div {
  padding: 0.6em;
}

.box1 {
  grid-column: 1;
  grid-row: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box2 {
  grid-column: 2;
  grid-row: 1;
  text-align: center;
}

.box3 {
  grid-column: 3;
  grid-row: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box4 {
  grid-column: 1/4;
  grid-row: 2;
  text-align: center;
}

.box5 {
  grid-column: 1/2;
  grid-row: 3;
}

.box6 {
  grid-column: 3/4;
  grid-row: 3;
}

.box7 {
  justify-content: stretch;
  grid-column: 1/4;
  grid-row: 4;
}

.box8 {
  grid-column: 1/2;
  grid-row: 6;
}

.box9 {
  grid-column: 3/4;
  grid-row: 5;
}

.box10 {
  grid-column: 3/4;
  grid-row: 10;
}

.box11 {
  grid-column: 1/2;
  grid-row: 10;
}

.box12 {
  grid-column: 1/4;
  grid-row: 11;
  text-align: center;
}

.box13 {
  grid-column: 1/3;
  grid-row: 5;
}

.box14 {
  grid-column: 1/4;
  grid-row: 7;
}

.footer {
  position: fixed;
  left: 180;
  bottom: 0;
  text-align: center;
  width: 1000px;
  max-width: 90%;
}

body {
  font-family: "Inter", sans-serif !important;
}

table {
  width: 100%;
  border-collapse: collapse;
}

table.table1,
table.table1 th,
table.table1 td {
  border: 1px solid silver;
}

table.table1 th,
table.table1 td {
  text-align: left;
  padding: 5px;
}

table.table1 tr:nth-child(even) {
  background-color: #f2f2f2;
}

table.table2 {
  border-collapse: collapse;
  width: 100%;
}

table.table2 th,
table.table2 td {
  color: #000;
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

hr.hr1 {
  border-top: 1px dotted rgb(63, 63, 63);
}

/* Pos Print */

.pos-print-body {
  font-family: "PT Sans", sans-serif;
  color: #000;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 15px;
}

.table .header {
  border-top: 2px dashed #000;
  border-bottom: 2px dashed #000;
}

.table {
  text-align: left;
}

.table .subtotal td:first-of-type {
  border-top: none;
}

.table .data td {
  border: none;
}

.table .discount td {
  border: none;
}

.table .subtotal td {
  border-top: 2px dashed #000;
  border-bottom: none;
}

.table .total td {
  border-top: 2px dashed #000;
  border-bottom: none;
}

.table .after-discount td {
  border-bottom: 2px dashed #000;
}

.table .net-amount td:first-of-type {
  border-top: none;
}

.table .net-amount td {
  border-top: 2px dashed #000;
}

.table .net-amount {
  border-bottom: 2px dashed #000;
}`, "",{"version":3,"sources":["webpack://./src/components/CRM/Quotes/QuoteDetails/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;AACxC;;AAEA,cAAc;;AAId;EACE,kCAAkC;EAClC,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":[".wrapper {\n  display: grid;\n  grid-template-columns: 2fr 3fr 2fr;\n  font-size: 12px;\n  padding: 10px 0;\n  margin: 0 auto;\n  grid-auto-rows: minmax(70px, auto);\n}\n\n.wrapper>div {\n  padding: 0.6em;\n}\n\n.box1 {\n  grid-column: 1;\n  grid-row: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.box2 {\n  grid-column: 2;\n  grid-row: 1;\n  text-align: center;\n}\n\n.box3 {\n  grid-column: 3;\n  grid-row: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.box4 {\n  grid-column: 1/4;\n  grid-row: 2;\n  text-align: center;\n}\n\n.box5 {\n  grid-column: 1/2;\n  grid-row: 3;\n}\n\n.box6 {\n  grid-column: 3/4;\n  grid-row: 3;\n}\n\n.box7 {\n  justify-content: stretch;\n  grid-column: 1/4;\n  grid-row: 4;\n}\n\n.box8 {\n  grid-column: 1/2;\n  grid-row: 6;\n}\n\n.box9 {\n  grid-column: 3/4;\n  grid-row: 5;\n}\n\n.box10 {\n  grid-column: 3/4;\n  grid-row: 10;\n}\n\n.box11 {\n  grid-column: 1/2;\n  grid-row: 10;\n}\n\n.box12 {\n  grid-column: 1/4;\n  grid-row: 11;\n  text-align: center;\n}\n\n.box13 {\n  grid-column: 1/3;\n  grid-row: 5;\n}\n\n.box14 {\n  grid-column: 1/4;\n  grid-row: 7;\n}\n\n.footer {\n  position: fixed;\n  left: 180;\n  bottom: 0;\n  text-align: center;\n  width: 1000px;\n  max-width: 90%;\n}\n\nbody {\n  font-family: \"Inter\", sans-serif !important;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\ntable.table1,\ntable.table1 th,\ntable.table1 td {\n  border: 1px solid silver;\n}\n\ntable.table1 th,\ntable.table1 td {\n  text-align: left;\n  padding: 5px;\n}\n\ntable.table1 tr:nth-child(even) {\n  background-color: #f2f2f2;\n}\n\ntable.table2 {\n  border-collapse: collapse;\n  width: 100%;\n}\n\ntable.table2 th,\ntable.table2 td {\n  color: #000;\n  padding: 8px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n}\n\nhr.hr1 {\n  border-top: 1px dotted rgb(63, 63, 63);\n}\n\n/* Pos Print */\n\n@import url(\"http://fonts.cdnfonts.com/css/vcr-osd-mono\");\n\n.pos-print-body {\n  font-family: \"PT Sans\", sans-serif;\n  color: #000;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: 15px;\n}\n\n.table .header {\n  border-top: 2px dashed #000;\n  border-bottom: 2px dashed #000;\n}\n\n.table {\n  text-align: left;\n}\n\n.table .subtotal td:first-of-type {\n  border-top: none;\n}\n\n.table .data td {\n  border: none;\n}\n\n.table .discount td {\n  border: none;\n}\n\n.table .subtotal td {\n  border-top: 2px dashed #000;\n  border-bottom: none;\n}\n\n.table .total td {\n  border-top: 2px dashed #000;\n  border-bottom: none;\n}\n\n.table .after-discount td {\n  border-bottom: 2px dashed #000;\n}\n\n.table .net-amount td:first-of-type {\n  border-top: none;\n}\n\n.table .net-amount td {\n  border-top: 2px dashed #000;\n}\n\n.table .net-amount {\n  border-bottom: 2px dashed #000;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
